"use client";

import { useCallback } from "react";
import {
  motion,
  useMotionValue,
  useTransform,
  useSpring,
} from "framer-motion";

// Интерактивный фон — aurora-градиенты, реагирующие на мышь
export function AuroraBackground() {
  const mouseX = useMotionValue(0.5);
  const mouseY = useMotionValue(0.5);

  // Плавные пружинные значения для позиции орбов
  const orb1X = useSpring(useTransform(mouseX, [0, 1], [15, 35]), { stiffness: 30, damping: 40 });
  const orb1Y = useSpring(useTransform(mouseY, [0, 1], [10, 30]), { stiffness: 30, damping: 40 });
  const orb2X = useSpring(useTransform(mouseX, [0, 1], [55, 75]), { stiffness: 25, damping: 45 });
  const orb2Y = useSpring(useTransform(mouseY, [0, 1], [50, 70]), { stiffness: 25, damping: 45 });
  const orb3X = useSpring(useTransform(mouseX, [0, 1], [60, 40]), { stiffness: 20, damping: 50 });
  const orb3Y = useSpring(useTransform(mouseY, [0, 1], [20, 45]), { stiffness: 20, damping: 50 });

  const handleMouseMove = useCallback(
    (e: React.MouseEvent) => {
      const { clientX, clientY } = e;
      mouseX.set(clientX / window.innerWidth);
      mouseY.set(clientY / window.innerHeight);
    },
    [mouseX, mouseY]
  );

  return (
    <div
      className="absolute inset-0 overflow-hidden pointer-events-auto"
      onMouseMove={handleMouseMove}
    >
      {/* Орб 1 — фиолетовый, крупный */}
      <motion.div
        className="absolute w-[700px] h-[700px] rounded-full opacity-[0.07] blur-[120px]"
        style={{
          background: "radial-gradient(circle, #a855f7, transparent 70%)",
          left: useTransform(orb1X, (v) => `${v}%`),
          top: useTransform(orb1Y, (v) => `${v}%`),
          translateX: "-50%",
          translateY: "-50%",
        }}
      />

      {/* Орб 2 — синий */}
      <motion.div
        className="absolute w-[500px] h-[500px] rounded-full opacity-[0.06] blur-[100px]"
        style={{
          background: "radial-gradient(circle, #3b82f6, transparent 70%)",
          left: useTransform(orb2X, (v) => `${v}%`),
          top: useTransform(orb2Y, (v) => `${v}%`),
          translateX: "-50%",
          translateY: "-50%",
        }}
      />

      {/* Орб 3 — бирюзовый, маленький */}
      <motion.div
        className="absolute w-[400px] h-[400px] rounded-full opacity-[0.04] blur-[100px]"
        style={{
          background: "radial-gradient(circle, #06b6d4, transparent 70%)",
          left: useTransform(orb3X, (v) => `${v}%`),
          top: useTransform(orb3Y, (v) => `${v}%`),
          translateX: "-50%",
          translateY: "-50%",
        }}
      />

      {/* Тонкая сетка */}
      <div
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />
    </div>
  );
}
